import { render, staticRenderFns } from "./dataViewPage.vue?vue&type=template&id=034612e0&"
import script from "./dataViewPage.vue?vue&type=script&lang=js&"
export * from "./dataViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/page/dataViewPage.vue"
export default component.exports